import React from "react";
import type {
  IGetNotificationsParams,
  IGetNotificationsResponse,
} from "../../types/notifications.types";

interface NotificationsContextType {
  noReadNotificationsLength: number;
  setNoReadNotificationsLength: React.Dispatch<React.SetStateAction<number>>;
  notifications: IGetNotificationsResponse | null;
  setNotifications: React.Dispatch<
    React.SetStateAction<IGetNotificationsResponse | null>
  >;
  revalidateNotifications: (
    params: IGetNotificationsParams
  ) => Promise<IGetNotificationsResponse | undefined>;
}

export const NotificationsContext =
  React.createContext<NotificationsContextType>({
    noReadNotificationsLength: 0,
    setNoReadNotificationsLength: () => {},
    notifications: {
      data: [],
      total: 1,
      totalPages: 1,
      unreadCount: 1,
      page: 1,
    },
    setNotifications: () => {},
    revalidateNotifications: async () => {
      return {
        data: [],
        total: 1,
        totalPages: 1,
        unreadCount: 1,
        page: 1,
      };
    },
  });
